module.exports = __webpack_public_path__ + "static/media/bsc.0401aeaa.svg";